// extracted by mini-css-extract-plugin
module.exports = {"textWrap":"style_textWrap__AWciQ","images":"style_images__hiQA_","contain":"style_contain___APNr","text":"style_text__P4OnQ","noImages":"style_noImages__xauUe"};